module.exports = __webpack_public_path__ + "static/media/gym_big.fd4e44f1.jpg";